(function () {
    var kksa_ab_schema = kksa_qs()["ab_schema"];//获取AB标识
    var kksa_param = {
        sdk_url: "https://static3w.kuaikanmanhua.com/assets/js/sensorsdata.min_3a36748.js",
        name: "kksa",
        server_url: "https://sa.kkmh.com/sa?project=kuaikan_app"
    };
    // if (!/www.kuaikanmanhua.com/.test(location.href)) {
    //     kksa_param.server_url           = 'https://sa.kkmh.com/sa?project=kuaikan_test';
    //     // kksa_param.show_log             = true;
    //     // kksa_param.debug_mode           = true;
    //     kksa_param.is_track_device_id   = true;
    // }

    if (!/h5.kuaikanmanhua.com/.test(location.href)) {
        kksa_param.server_url = "https://sa.kkmh.com/sa?project=kuaikan_test";
        // kksa_param.show_log             = true;
        kksa_param.debug_mode = true;
        kksa_param.is_track_device_id = true;
    }

    if (/track_debug=false/.test(location.href)) {
        kksa_param.debug_mode = false;
    }


    //获取url携带参数
    function kksa_qs() {
        var assoc = {};
        var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")) };
        var queryString = location.search.substring(1);
        queryString = queryString.replace(/\?/g, "&");
        var keyValues = queryString.split("&");
        for (var i in keyValues) {
            var key = keyValues[i].split("=");
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }
        return assoc;
    }

    (function (para) {
        var p = para.sdk_url, n = para.name, w = window, d = document, s = "script", x = null, y = null;
        w["sensorsDataAnalytic201505"] = n;
        w[n] = w[n] || function (a) { return function () { (w[n]._q = w[n]._q || []).push([a, arguments]) } };
        var ifs = ["track", "quick", "register", "registerPage", "registerOnce", "registerSession", "registerSessionOnce", "trackSignup", "trackAbtest", "setProfile", "setOnceProfile", "appendProfile", "incrementProfile", "deleteProfile", "unsetProfile", "identify", "login", "logout"];
        for (var i = 0; i < ifs.length; i++) {
            w[n][ifs[i]] = w[n].call(null, ifs[i]);
        }
        if (!w[n]._t) {
            x = d.createElement(s);
            y = d.getElementsByTagName(s)[0];
            x.async = 1;
            x.src = p;
            y.parentNode.insertBefore(x, y);
            w[n].para = para;

            x.onload = function () {
                var pp = {
                    H5Page: location.href
                };

                if (kksa_ab_schema) {
                    pp.AbTestTagName = kksa_ab_schema;
                }
                // registerPage 设置公用属性，在所有事件中都会出现。
                kksa.registerPage(pp);
            };
        }
    })(kksa_param);
})();


// WEBPACK FOOTER //
// ./src/assets/js/common/kksa_kuaikanapp.js